<template>
  <Preview :isCreateDefaultTemplate="true"></Preview>
</template>

<script>

export default {
  name: 'App',
   setup() {},
}
</script>

<style>

</style>
